// extracted by mini-css-extract-plugin
module.exports = {"main-container":"budgetAlert_main-container__q-a0q"};